/**
 * Renders a filled star row with brass-lit / dim ticks.
 * value is 1..5 inclusive; supports half stars via ".5"
 */
export default function Stars({ value, small = false, testid }) {
  if (value === null || value === undefined) return null;
  const size = small ? "text-xs" : "text-base";
  const full = Math.floor(value);
  const half = value - full >= 0.5;
  const total = 5;
  const marks = [];
  for (let i = 0; i < total; i++) {
    if (i < full) marks.push("full");
    else if (i === full && half) marks.push("half");
    else marks.push("empty");
  }
  return (
    <span
      className={`inline-flex gap-0.5 leading-none ${size}`}
      aria-label={`${value} out of 5 stars`}
      data-testid={testid}
    >
      {marks.map((m, i) => (
        <span key={i}>
          {m === "full" && <span className="star-lit">★</span>}
          {m === "half" && (
            <span className="relative">
              <span className="star-dim">★</span>
              <span
                className="star-lit absolute inset-0 overflow-hidden"
                style={{ width: "50%" }}
              >
                ★
              </span>
            </span>
          )}
          {m === "empty" && <span className="star-dim">★</span>}
        </span>
      ))}
    </span>
  );
}
